/**
 * @fileoverview Hook de UI Layer para generar el handler de toggle en InboxChatListMC.
 * @module useInboxChatListToggleUI
 * @category Hook - UI Layer
 * @since 3.1.0
 * @version 3.1.0
 */
import { useCallback } from 'react';

/**
 * Hook especializado de UI Layer para generar el handler de toggle de selección de conversación.
 *
 * Implementa el patrón de **UI Layer** con separación estricta de responsabilidades,
 * enfocándose únicamente en la generación del callback para alternar selección.
 *
 * @function useInboxChatListToggleUI
 * @category Hook - UI Layer
 *
 * @param {function} toggleConversationSelection - Handler para alternar la selección
 * @returns {function} getOnToggle - Función memoizada para obtener el handler de toggle
 *
 * @example
 * const getOnToggle = useInboxChatListToggleUI(toggleConversationSelection);
 * <ConversationItemMC onToggle={getOnToggle(conversation.id)} />
 *
 * @see InboxChatListMC
 */
export default function useInboxChatListToggleUI(toggleConversationSelection) {
  const getOnToggle = useCallback(
    (conversation) => () => toggleConversationSelection({
      id: conversation.id,
      platform: conversation.platform,
      assignedAgent: conversation.assignedAgent,
      statusChat: conversation.statusChat
    }),
    [toggleConversationSelection]
  );
  return getOnToggle;
}
